import { render, staticRenderFns } from "./ZappingColumns.vue?vue&type=template&id=9e29734e&scoped=true"
import script from "./ZappingColumns.vue?vue&type=script&lang=js"
export * from "./ZappingColumns.vue?vue&type=script&lang=js"
import style0 from "./ZappingColumns.vue?vue&type=style&index=0&id=9e29734e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e29734e",
  null
  
)

export default component.exports